<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="false" />
    <v-snackbar v-model="showsnackbar" color="primary" right :timeout="timeout">
      {{msg}}
      <v-btn text @click="showsnackbar = false">
        <v-icon style="color:white;">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-layout  wrap >
      <v-flex xs12 md12 pa-0>
        <v-card id="app_height" outlined tile>
          <v-layout wrap justify-space-around>
            <v-flex xs12 md12 pa-8>
              <v-layout wrap>
                <v-flex xs12 md12 text-center>
                  <span style="font-size:20px;font-weight:500;">Internship/Training List</span>
                </v-flex>
              </v-layout>
            <v-layout wrap >
              <v-flex md10></v-flex>
              
            <v-flex md2 text-center>
              <v-select :items="items" v-model="category" label="Solo field" solo></v-select>
            </v-flex>
          </v-layout>
              <v-layout wrap px-2 justify-center>
                <v-flex xs12 md12>
                  <v-card-title>
                    <v-spacer></v-spacer>
                    <!-- <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      color="#26af82"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field> -->
                  </v-card-title>

                  <v-data-table
                    :headers="headers"
                    dense
                    :items="Queries"
                    :search="search"
                    :sort-desc="[false, true]"
                    color="#26af82"
                    :loading="appLoading"
                    loading-text="Loading... Please wait"
                    class="elevation-1"
                    
                  >
                    
                    <template v-slot:item._id="{ item }">
                      <router-link tag='span' :to="'/InternTraineedetail/'+item._id">
                        <v-btn small text color="#26af82" block>View</v-btn>
                      </router-link>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import VueElementLoading from "vue-element-loading";
export default {
  components: {
    VueElementLoading
  },
  data() {
    return {
      appLoading: false,
      showsnackbar: false,
      timeout: 3000,
      msg: null,
      search: null,
      headers: [
        { text: "Name", value: "name", },
        { text: "Email", value: "email", },
        { text: "Contact", value: "ph" },
        { text: "Qualification", value: "qualificationId.qualificationName", },
        { text: "Technology", value: "technology.technologyName",},
        { text: "Action", align: "center", value: "_id" }
      ],
      items:[
        { text: "Internship", value: "internship", },
        { text: "Training", value: "training", },
        { text: "All", value: "", },
      ],
      Queries: [],
      category:'',
    };
  },
  beforeMount() {
    this.getList();
  },
watch:{
category(){
  this.getList();
}
},
  methods: {
    getList() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/applications/list",
        headers: {
          token: localStorage.getItem("token")
        },
        data:{
          category:this.category
        }
      })
        .then(response => {
          this.appLoading = false;
          if (response.data.status) {
             var list = response.data.data;
             
             this.Queries = [];
             for(var i=0;i<list.length;i++){
               
               if(list[i].category != 'career')

               this.Queries.push(list[i])

             }
            
            
          } else {
            this.msg = response.data.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch(err => {
          this.appLoading = false;
          this.msg = err.response.msg;
          this.showsnackbar = true;
        });
    }
  }
};
</script>
<style>
@media only screen and (min-width: 800px) {
  #app_height {
    min-height: 80vh;
    min-width: 80vw;
  }
}
</style>